import React from 'react';
import { Trans } from 'react-i18next';
import { IInviteMessage } from '../InviteMembersModal.d';
import TrackLink from '../../../utils/trackLink';

const EmailButton = ({
  shareMessage,
  shareHeader,
}: // eslint-disable-next-line no-shadow
Pick<IInviteMessage, 'shareMessage' | 'shareHeader'>) => (
  <TrackLink
    className="jg-btn jg-btn--email jg-h4 jg-space-mbms"
    href={`mailto:?subject=${encodeURIComponent(
      shareHeader,
    )}&body=${encodeURIComponent(shareMessage)}`}
    trackingData={{
      action_name: 'link click',
      subtype: 'invite',
      event: 'link click',
      event_value: 'email',
      page_section: 'invite team members',
    }}
  >
    <Trans i18nKey="share.button.email" />
  </TrackLink>
);

export default EmailButton;
